import { AiFillInfoCircle } from "react-icons/ai";
import { formatCurrency } from "../../../utils/formatCurrency";
import { SummaryFieldsAnnualProps, SummaryAnnualProps } from "../../../pages/Credit/CreditTabs";
import { toast } from "react-toastify";
import { api } from "../../../services/axios";

interface InvestValuesAnnualFormProps {
    isSudamSudene: boolean;
    validated: boolean;
    investValueSudamSudeneCOPDIM: number;
    investValueOthersRegionsPDIM: number;
    serviceId: string;
    creditId: string;
    companyCnpj: string;
    othersRegionsConsolidation: SummaryFieldsAnnualProps;
    sudamSudeneCOConsolidation: SummaryFieldsAnnualProps;
    setInvestValueOthersRegions: React.Dispatch<React.SetStateAction<number>>;
    setInvestValueSudamSudeneCO: React.Dispatch<React.SetStateAction<number>>;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    setSummaryValues: React.Dispatch<React.SetStateAction<SummaryAnnualProps | undefined>>;
}

export default function InvestValuesAnnualForm(props: InvestValuesAnnualFormProps) {
    const validNumbers = new RegExp(/^\d+(\.\d{1,})?$/i);

    function validate(value: string) {
        var resp = validNumbers.test(value);

        return resp
    }

    async function reCalcAllSummaryValuesAnnual() {
        try {
            props.setLoading(true);

            await api.get(`/InvestValue/ReCalcInvestValuesAnnual/${props.serviceId}/${props.creditId}`).then(resp => {
                if (resp.data.statusCode == 200) {
                    props.setSummaryValues(resp.data.data);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            props.setLoading(false);
        }
    }

    async function updateValue() {
        try {
            props.setLoading(true);

            await api.put('/InvestValue/Put', {
                creditId: props.creditId,
                serviceId: props.serviceId,
                tenantCNPJ: props.companyCnpj,
                investValueSudamSudeneCO: props.isSudamSudene ? props.investValueSudamSudeneCOPDIM : null,
                investValueOthersRegions: !props.isSudamSudene ? props.investValueOthersRegionsPDIM : null
            }).then(resp => {
                if (resp.data.statusCode == 200) {
                    reCalcAllSummaryValuesAnnual();
                }
                else {
                    toast.error("Houve um erro ao atualizar o valor!");
                    props.setLoading(false);
                }
            })
        } catch (error: any) {
            toast.error(error);
            props.setLoading(false);
        }
    }

    return (
        <div className='card bg-light'>
            <div className='table-responsive'>
                <form>
                    <table className='summary-table'>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    PD&IM - Investimento em PD&I Mínimo
                                </th>
                                <th>
                                    PD&IC - Investimento em PD&I Complementar
                                </th>
                                <th>
                                    Faturamento Total
                                </th>
                                <th>
                                    Valor de Crédito
                                </th>
                                <th>
                                    Limite de Crédito
                                </th>
                                <th>
                                    Crédito - Excedente
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>
                                    Sudam/ Sudene/ Centro-Oeste
                                </th>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        defaultValue={props.isSudamSudene || props.validated ? formatCurrency(props.investValueSudamSudeneCOPDIM?.toFixed(2) ?? "0.00") : props.investValueSudamSudeneCOPDIM?.toFixed(2).replace(".", ",") ?? "0,00"}
                                        onChange={e => props.setInvestValueSudamSudeneCO(validate(e.target.value.replace(".", "").replace(",", ".")) ? parseFloat(e.target.value.replace(".", "").replace(",", ".")) : 0)}
                                        placeholder='0,00'
                                        disabled={true}
                                        onBlur={updateValue}
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input type="text"
                                        className='form-control'
                                        defaultValue={props.isSudamSudene || props.validated ? formatCurrency(props.sudamSudeneCOConsolidation.investValuePDIC?.toFixed(2) ?? "0.00") : props.sudamSudeneCOConsolidation.investValuePDIC?.toFixed(2).replace(".", ",") ?? "0,00"}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency(props.sudamSudeneCOConsolidation.invoicingConsolidation.toFixed(2))}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency(props.sudamSudeneCOConsolidation.creditValue.toFixed(2))}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency(props.sudamSudeneCOConsolidation.creditLimit.toFixed(2))}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.sudamSudeneCOConsolidation.surplusCreditValue.toFixed(2)))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Outras Regiões
                                </th>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        placeholder='0,00'
                                        defaultValue={!props.isSudamSudene || props.validated ? formatCurrency(props.investValueOthersRegionsPDIM?.toFixed(2) ?? "0.00") : props.investValueOthersRegionsPDIM?.toFixed(2).replace(".", ",") ?? "0,00"}
                                        onChange={e => props.setInvestValueOthersRegions(validate(e.target.value.replace(".", "").replace(",", ".")) ? parseFloat(e.target.value.replace(".", "").replace(",", ".")) : 0)}
                                        disabled={true}
                                        onBlur={updateValue}
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input type="text"
                                        className='form-control'
                                        placeholder='0,00'
                                        defaultValue={!props.isSudamSudene || props.validated ? formatCurrency(props.othersRegionsConsolidation.investValuePDIC?.toFixed(2) ?? "0.00") : props.othersRegionsConsolidation.investValuePDIC?.toFixed(2).replace(".", ",") ?? "0,00"}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency(props.othersRegionsConsolidation.invoicingConsolidation.toFixed(2))}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency(props.othersRegionsConsolidation.creditValue.toFixed(2))}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency(props.othersRegionsConsolidation.creditLimit.toFixed(2))}
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.othersRegionsConsolidation.surplusCreditValue.toFixed(2)))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                    <AiFillInfoCircle size={15} />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Total
                                </th>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.investValueOthersRegionsPDIM +
                                            props.investValueSudamSudeneCOPDIM).toFixed(2))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.othersRegionsConsolidation.investValuePDIC +
                                            props.sudamSudeneCOConsolidation.investValuePDIC).toFixed(2))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.othersRegionsConsolidation.invoicingConsolidation +
                                            props.sudamSudeneCOConsolidation.invoicingConsolidation).toFixed(2))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.othersRegionsConsolidation.creditValue +
                                            props.sudamSudeneCOConsolidation.creditValue).toFixed(2))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.othersRegionsConsolidation.creditLimit +
                                            props.sudamSudeneCOConsolidation.creditLimit).toFixed(2))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className='form-control'
                                        value={formatCurrency((props.othersRegionsConsolidation.surplusCreditValue +
                                            props.sudamSudeneCOConsolidation.surplusCreditValue).toFixed(2))
                                        }
                                        readOnly={true}
                                        disabled
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
    )
}